export const enKnowledgeTranslations = {
    KNOWLEDGE__TITLE: 'List of documentation',
    KNOWLEDGE__EMPTY: 'Nothing was found for your query',
    KNOWLEDGE__FEEDBACK: 'Was this article helpful?',
    KNOWLEDGE__MESSAGE: 'Thank you for your feedback',

    KNOWLEDGE__SYSTEM_STATUS: 'System status',
};
